import logo from './logo192.png';
import './App.scss';
import Header from "./components/Header"
import Content from "./components/Content"
import Sidebar from './components/Sidebar';

function App() {
  return (
    <div className="App">
      <Header />

      <Content />

    </div>
  );
}

export default App;
